import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import AuthContext from "../contexts/AuthContext/AuthContext";
import Home from "./Home";
import { homePathForRole } from "./ProtectedRoute";

// Landing for the root path "/". Everyone (including signed-out visitors) sees
// the games home here; only clinicians are sent to the provider portal.
const RoleLanding = () => {
  const { isInitializing, isClinician } = useContext(AuthContext);

  if (isInitializing) {
    return null;
  }
  if (isClinician) {
    return <Navigate to={homePathForRole("clinician")} replace />;
  }
  return <Home />;
};

export default RoleLanding;
